import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';

/*
  Generated class for the ChatroomProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ChatroomProvider {
  constructor(public http: HttpProvider) {
    console.log('Hello ChatroomProvider Provider');
  }

  getGroupList() {
    return this.http.hPost('/group/get_group_list');
  }

  getChatroomList(scope, order, page, pagesize) {
    let params = {
      date_type: scope,
      order: order,
      page: page,
      pagesize: pagesize,
    };
    console.log(params);
    return this.http.hPost('/statistics/statistics_chatroom', params);
  }

  getChatroomInfo(chatroom_id, scope?) {
    let params = {
      chatroom_id: chatroom_id,
      date_type: scope,
    };
    return this.http.hPost('/chatroom/get_chatroom_info', params);
  }

  getMemberList(chatroom_id, scope, order, page, pagesize, is_influence?) {
    let params = {
      chatroomname: chatroom_id,
      order: order,
      date_type:scope,
      page: page,
      pagesize: pagesize,
    };
    return this.http.hPost('/group/statistics_member', params);
  }

  getExceptionMemberList(chatroomname, scope) {
    let params = {
      chatroomname: chatroomname,
      date_type: scope,
    };
    return this.http.hPost('/group/get_in_out_members', params);
  }

  getActiveRate(chatroom_id, scope) {
    let params = {
      chatroom_id: chatroom_id,
      scope: scope,
    };
    return this.http.hPost('/chatroom/get_active_tendency', params);
  }

  getMessageRate(chatroom_id, scope) {
    let params = {
      chatroom_id: chatroom_id,
      scope: scope,
    };
    return this.http.hPost('/chatroom/get_msg_component', params);
  }

  getMessageTendency(chatroom_id, scope) {
    let params = {
      chatroom_id: chatroom_id,
      scope: scope,
    };
    return this.http.hPost('/chatroom/get_chatroom_tendency', params);
  }

  getRelation(chatroom_id) {
    let params = {
      chatroom_id: chatroom_id,
    };
    return this.http.hPost('/chatroom/get_member_relationship', params);
  }

  getLiftCycle(chatroom_id) {
    let params = {
      chatroom_id: chatroom_id,
    };
    return this.http.hPost('/chatroom/get_life_cycle', params);
  }

  getPhoneRate(chatroom_id) {
    let params = {
      chatroom_id: chatroom_id,
    };
    return this.http.hPost('/chatroom/get_phone_component', params);
  }
  getGender(chatroom_id) {
    let params = {
      chatroom_id: chatroom_id,
    };
    return this.http.hPost('/chatroom/get_gender_tendency', params);
  }

  getGeoData(chatroomname) {
    let params = {
      chatroomname: chatroomname,
    };
    return this.http.hPost('/statistics/member_region_distr', params);
  }

  getSaleQR() {
    return this.http.hPost('/get_sale_qr');
  }

  getBotQr() {
    return this.http.hPost('/itchat/get_bot_qr');
  }

  geUserStatus() {
    return this.http.hPost('/get_user_status');
  }
  getActiveCount(scope){
    return this.http.hPost('/statistics/get_active_chatroom_count',{date_type:scope})
  }

  getNonActiveChatroom(page,pagesize,scope){
    let params ={
      date_type:scope,
      page:page,
      pagesize:pagesize
    };
    return this.http.hPost('/statistics/get_non_active_chatroom_list',params);
  }

  getPotentialChatroomList(page, pagesize) {
    let params = {
      page: page,
      pagesize: pagesize,
    };
    return this.http.hPost('/chatroom/get_potential_chatroom_list', params);
  }

  turnOnObserver(chatroom_id) {
    let params = {
      chatroom_id_list: chatroom_id,
    };
    return this.http.hPost('/chatroom/turn_on_observer', params);
  }

  applyChatroomOwner(chatroom_id) {
    let params = {
      chatroom_id: chatroom_id,
    };
    return this.http.hPost('/chatroom/apply_chatroom_owner', params);
  }

  getExceptionList(chatroom_id, scope) {
    let params = {
      chatroom_id: chatroom_id,
      scope: scope,
    };
    return this.http.hPost('/chatroom/get_chatroom_tendency', params);
  }

  getActiveList(chatroom_id) {
    let params = {
      chatroom_id: chatroom_id,
    };
    return this.http.hPost('/chatroom/get_active_list', params);
  }

  getAvgActiveList(chatroom_id) {
    let params = {
      chatroom_id: chatroom_id,
    };
    return this.http.hPost('/chatroom/get_avg_active_list', params);
  }

  getPeriodData(chatroomname,date_type){
    let params = {
      chatroomname:chatroomname,
      date_type:date_type
    };
    return this.http.hPost('/statistics/chatroom_period_avg',params);
  }
  getTrendData(chatroomname,date_type){
    let params = {
      chatroomname:chatroomname,
      date_type:date_type
    };
    return this.http.hPost('/statistics/chatroom_dynamic_trend',params);
  }
  getGenderData(chatroomname){
    let params = {
      chatroomname:chatroomname,
    };
    return this.http.hPost('/statistics/member_genders',params);
  }

  getRankingData(date_type,rank_type){
    let params = {
      date_type:date_type,
      rank_type:rank_type
    };
    return this.http.hPost('/statistics/rank_list',params);
  }

  getRankDetail(date_type,rank_type,username){
    let params = {
      date_type:date_type,
      rank_type:rank_type,
      username:username
    };
    return this.http.hPost('/statistics/rank_detail',params);
  }

}



// WEBPACK FOOTER //
// ./src/providers/chatroom/chatroom.ts